﻿
;
window.SetUpBurgerNav = function () {

	var burgerButton = document.getElementById('BurgerButton');
	var nav = document.getElementById('MainNavigation');

	var expandedClassName = 'expanded';

	function toggleMenu() {

		if (nav.classList.contains(expandedClassName)) {
			// is expanded so collapse...

			burgerButton.setAttribute('aria-expanded', 'false');

			nav.classList.remove(expandedClassName);
			burgerButton.classList.remove(expandedClassName);

		} else {
			// is collapsed so expand ...

			nav.classList.add(expandedClassName);
			burgerButton.classList.add(expandedClassName);

			burgerButton.setAttribute('aria-expanded', 'true');
        }

	}

	if (burgerButton != null) {
		burgerButton.addEventListener('click', function () {
			toggleMenu();
		});
	}

};

if (document.readyState !== 'loading') {
	window.SetUpBurgerNav();
} else {
	document.addEventListener('DOMContentLoaded', function () {
		window.SetUpBurgerNav();
	});
}